import { InlineFixtureVersionsV1 } from '@geckoal/gecko-api-client'

export type InlineFixtureVersionItem = {
    value: InlineFixtureVersionsV1
    shortTitle: string
    longTitle: string
}

export const ALL_INLINE_FIXTURE_VERSIONS: InlineFixtureVersionItem[] = [
    {
        value: InlineFixtureVersionsV1.NptV1,
        shortTitle: shortTitleForInlineFixtureVersion(InlineFixtureVersionsV1.NptV1),
        longTitle: `${shortTitleForInlineFixtureVersion(InlineFixtureVersionsV1.NptV1)} - Threaded Sensor`
    },
    {
        value: InlineFixtureVersionsV1.NutV1,
        shortTitle: shortTitleForInlineFixtureVersion(InlineFixtureVersionsV1.NutV1),
        longTitle: `${shortTitleForInlineFixtureVersion(InlineFixtureVersionsV1.NutV1)} - Sensor with Lock Nut`
    }
]

export function shortTitleForInlineFixtureVersion(installType: InlineFixtureVersionsV1 | string): string {
    if (installType === InlineFixtureVersionsV1.NptV1) return 'NPT'
    if (installType === InlineFixtureVersionsV1.NutV1) return 'NUT'
    return installType
}
